import { graphql } from "./generated/gql";

export const SponsorProjectsQuery = graphql(`
  query SponsorProjects($sponsorId: ID!) {
    sponsorProjects(sponsorId: $sponsorId) {
      sponsorProjectId
      name
      projectUrl
      isCompleted
    }
  }
`);
